import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowServiceReviewBlockConfigSchema = z.object({
    transactionType: z.string().optional(),
    submissionMode: z.string().optional(),
    payorPortal: z.string(),
    patientInsuranceId: z.string().optional(),
    patientOrder: z.string().optional(),
    customPayload: z.string().optional(),
    fileReference: z.string().optional(),
    caseId: z.string().optional(),
    description: z.string().optional(),
    isTest: z.boolean().optional(),
    timeout: FlowDurationSchema,
});
export const FlowServiceReviewBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.ServiceReview),
    config: FlowServiceReviewBlockConfigSchema,
});
//# sourceMappingURL=config.js.map